<div
  #tableContainer
  [hidden]="!isActive"
  [ngClass]="['topo-data-table', leftDrawerOpenClass, embedded ? 'embedded' : 'full-screen']">
  <div>
    @if (showHeader) {
      <div
        class="table-header"
        [ngClass]="{ 'collapse-header': collapseHeader }"
        fxLayout="row"
        fxLayoutAlign="space-between center">
        <div
          fxLayout="row"
          fxLayoutAlign="start center">
          @if (headerIcon) {
            <div><img src="{{ headerIcon }}" /></div>
          }
          @if (headerLabel) {
            <div
              class="table-label ml-3"
              [ngClass]="{ 'embedded': embedded }">
              {{ headerLabel }}
            </div>
          }
          @if (showButtonBar) {
            <div
              class="button-bar"
              [ngStyle]="{ 'top': tabs?.length > 0 ? '122px' : '80px' }"
              fxLayout="row"
              fxLayoutAlign="start center">
              @if (showSelectedCount && !!selectedCount) {
                <div class="count-label mr-4">
                  {{ 'TABLE.SELECTED-COUNT' | translate: { value: selectedCount } }}
                </div>
              }
              <div>
                <ng-content></ng-content>
              </div>
            </div>
            <ng-content select="[center-content]"></ng-content>
          }
        </div>
        @if (needsRefresh === true) {
          <button
            class="button is-primary is-medium"
            (click)="onRefreshClick()">
            <i class="icon icon-refresh"></i>
          </button>
        }
        <div
          fxLayout="row"
          fxLayoutAlign="start center">
          @if (showSearch) {
            <div
              fxLayout="row"
              fxLayoutAlign="end center">
              @if (searchVisible) {
                <div
                  class="search-field"
                  fxLayout="row"
                  fxLayoutAlign="space-between center"
                  [formGroup]="form">
                  <input
                    type="text"
                    class="search-text-field"
                    placeholder="{{ 'TABLE.SEARCH-PLACEHOLDER' | translate }}"
                    formControlName="filter" />
                  <div
                    fxLayout="row"
                    fxLayoutAlign="start center"
                    class="search-button">
                    <div
                      class="pr-3"
                      fxLayoutAlign="start center">
                      <i class="icon icon-search"></i>
                    </div>
                    <div
                      class="pl-3 pr-3 hide-search-button"
                      (click)="hideSearch()"
                      fxLayoutAlign="start center">
                      <i class="icon icon-small_close-X"></i>
                    </div>
                  </div>
                </div>
              }
              @if (!searchVisible) {
                <div
                  class="search-button mr-3 pt-2"
                  [ngClass]="{ 'embedded': embedded }"
                  (click)="onShowSearch()">
                  <i class="icon icon-search"></i>
                </div>
              }
              @if (showMenu) {
                <div
                  fxLayout="row"
                  fxLayoutAlign="start center"
                  class="mr-3">
                  <topo-action-menu
                    #menu
                    size="{{ embedded ? 'normal' : 'large' }}">
                    @if (!!dataset) {
                      <topo-action
                        label="{{ 'TABLE.EDIT-COLUMNS' | translate }}"
                        icon="icon-columns"
                        (actionClick)="editColumns()"></topo-action>
                    }
                    @if (showRowGroups === true) {
                      <topo-action
                        label="{{ (showRowGroup ? 'TABLE.HIDE-GROUP-ROWS' : 'TABLE.SHOW-GROUP-ROWS') | translate }}"
                        icon="icon-group-rows"
                        (actionClick)="groupRows()"></topo-action>
                    }
                    @if (hideStateMenu !== true) {
                      <topo-action
                        label="{{ 'TABLE.RESET-STATE' | translate }}"
                        icon="icon-arrow-undo"
                        (actionClick)="onResetState()"></topo-action>
                    }
                    @if (datasetTemplates?.length > 0) {
                      <topo-action-menu
                        size="{{ embedded ? 'normal' : 'large' }}"
                        icon="cloud_download"
                        submenuLabel="{{ 'TABLE.EXPORT' | translate }}">
                        <topo-action
                          label="{{ 'TABLE.EXPORT-TO-EXCEL' | translate }}"
                          image="/assets/images/files/Filetype_XLS.svg"
                          (actionClick)="exportToExcelClicked()"></topo-action>
                        @for (template of datasetTemplates; track template.uId) {
                          <div>
                            <topo-action
                              label="{{
                                (datasetTemplates.length > 1 ? 'TABLE.EXPORT-TO-WORD-USING' : 'TABLE.EXPORT-TO-WORD')
                                  | translate: { name: template.name }
                              }}"
                              image="/assets/images/files/Filetype_DOC.svg"
                              (actionClick)="exportToDocumentClicked(template, 1)"></topo-action>
                          </div>
                        }
                      </topo-action-menu>
                    }
                    @if (!(datasetTemplates?.length > 0) && !hideDownloadButton) {
                      <topo-action
                        label="{{ 'TABLE.DOWNLOAD' | translate }}"
                        icon="icon-cloud_download"
                        (actionClick)="exportToExcelClicked()"></topo-action>
                    }
                  </topo-action-menu>
                </div>
              }
              <ng-content select="aux-buttons"></ng-content>
              @if (showNewButton) {
                <button
                  class="button is-primary is-medium"
                  (click)="onNewClick()">
                  <i class="icon icon-add_plus_zoom-in"></i>
                  <span>{{ newLabel }}</span>
                </button>
              }
            </div>
          }
          @if (!showMenu && showDownload) {
            <div
              class="download-button"
              [attr.title]="'TABLE.EXPORT' | translate"
              (click)="exportToExcelClicked()">
              <i class="icon icon-cloud_download"></i>
            </div>
          }
        </div>
      </div>
    }
    <div #selectedEntityActionsContainer>
      <ng-content select="selected-entity-actions"></ng-content>
    </div>
    <div
      fxLayout="row"
      fxLayoutAlign="start center"
      style="border-bottom: 1px solid var(--neutral-color-400)">
      @for (tab of tabs; track tab.uId) {
        <div
          (click)="tabClicked(tab.uId)"
          class="tab"
          [ngClass]="{ 'selected-tab': selectedTab === tab.uId }">
          <div
            fxLayout="row"
            fxLayoutAlign="start center">
            @if (!tab.iconSettings?.isCustomIcon) {
              <div
                class="asset-icon mr-1"
                [style]="'background-color:' + (tab.iconSettings?.color || 'var(--neutral-color-000)') + ';color: var(--neutral-color-000)'"
                fxLayout="row"
                fxLayoutAlign="space-around center">
                <div
                  class="material-icons"
                  style="font-size: 16px">
                  {{ tab.iconSettings?.iconPath }}
                </div>
              </div>
            }
            @if (!!tab.iconSettings?.isCustomIcon) {
              <div
                class="asset-icon mr-1"
                [style]="
                  'background-color:' +
                  (!tab.iconSettings ? 'var(--neutral-color-000)' : tab.iconSettings?.color) +
                  ';color: var(--neutral-color-000)'
                ">
                <img
                  [src]="tab.iconSettings?.iconPath | safeUrl"
                  style="width: 16px; height: 16px; margin: 4px 0px 0px 4px" />
              </div>
            }
            <div
              [ngStyle]="{
                'color': selectedTab === tab.uId ? 'var(--neutral-gray-900)' : 'var(--neutral-gray-600)',
                'font-weight': selectedTab === tab.uId ? '600' : '400'
              }">
              {{ tab.label }}
            </div>
          </div>
        </div>
      }
    </div>
    <div
      class="body"
      [id]="id"
      [ngStyle]="{ 'visibility': tableHidden ? 'hidden' : 'visible', 'height': tableHeightCalc(), 'width': width }">
      <ag-grid-angular
        theme="legacy"
        columnMenu="legacy"
        [animateRows]="false"
        rowModelType="serverSide"
        [hidden]="!isTableLoading"
        class="ag-theme-alpine grid"
        [columnDefs]="columns"
        [headerHeight]="embedded ? (rowHeight ? rowHeight : 36) : 56"
        [rowHeight]="embedded ? (rowHeight ? rowHeight : 36) : 56"
        [pagination]="true"
        [suppressPaginationPanel]="true"
        [paginationPageSize]="take"
        [components]="frameworkComponents"
        (gridReady)="gridReady($event)"
        (selectionChanged)="selectionChanged($event)"
        (firstDataRendered)="firstDataRendered($event)"
        (rowSelected)="onRowSelected($event)"
        [rowSelection]="rowSelection"
        [suppressCellFocus]="true"
        [suppressCutToClipboard]="true"
        [cacheBlockSize]="take"
        [getRowId]="getRowId"
        [rowGroupPanelShow]="groupShowType"
        [autoGroupColumnDef]="autoGroupColumnDef"
        [getLocaleText]="getLocaleText"
        [suppressColumnMoveAnimation]="true"
        [suppressNoRowsOverlay]="suppressNoRowsOverlay"
        [groupRowRendererParams]="groupRowRendererParams"
        [getServerSideGroupLevelParams]="getServerSideGroupLevelParams"
        (rowDoubleClicked)="rowDoubleClicked($event)"
        (sortChanged)="sortChanged($event)"
        (columnRowGroupChanged)="groupChanged($event)"
        (columnResized)="columnResized($event)"
        (filterChanged)="filterChanged($event)"
        (dragStopped)="dragStopped($event)"></ag-grid-angular>

      <!-- Empty State -->
      @if (!isDataLoading && totalCount === 0 && !!emptyMessage) {
        <div
          class="empty-state"
          fxLayout="column"
          fxLayoutAlign="center center">
          <div class="empty-state-icon">
            <div class="archive-icon"></div>
          </div>
          <div class="empty-state-text">
            <p>{{ emptyMessage | translate }}</p>
          </div>
        </div>
      }
    </div>
  </div>
  @if (!tableHidden && !hidePager) {
    <topo-pager
      [hidePageLinks]="hidePageLinks"
      [skip]="skip"
      [take]="take"
      [totalCount]="totalCount"
      [steps]="steps"
      [showChangeRowCount]="true"
      [maxPagesForShowAll]="maxPagesForShowAll"
      (paginate)="onPaginate($event)"
      (takeChanged)="onTakeChanged($event)"></topo-pager>
  }
</div>

<topo-table-select-columns
  [visible]="showEditColumns"
  [showSystemFields]="showSystemFields"
  [schema]="!!dataset ? dataset.schema : null"
  (close)="closeEditColumns()"
  (save)="saveEditColumns($event)"
  (reset)="resetEditColumns()"
  [columns]="tableColumns"></topo-table-select-columns>
